/**
 * Locales soportados por el producto. Fuente de verdad única —
 * la web, la admin y la API consumen estas constantes.
 *
 * Para añadir un idioma: extender `LOCALES` aquí y propagar el
 * cambio (catálogo de mensajes en apps/web, hreflang, slugs,
 * formularios de admin, schemas de la API).
 */
export const LOCALES = ['es', 'ca', 'en'] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'es';

/**
 * Mapeo de locale interno → código BCP 47 que se usa en
 * `<html lang>`, `og:locale` y `hreflang`. La fuente común está
 * aquí para que web, sitemap y metadata no diverjan.
 */
export const LOCALE_TO_HTML_LANG: Record<Locale, string> = {
  es: 'es-ES',
  ca: 'ca',
  en: 'en',
};

export const LOCALE_TO_OG_LOCALE: Record<Locale, string> = {
  es: 'es_ES',
  ca: 'ca_ES',
  en: 'en',
};

export function isLocale(value: string): value is Locale {
  return (LOCALES as readonly string[]).includes(value);
}

/**
 * Nombre de la cookie donde la web persiste la preferencia
 * manual del usuario. La elige el middleware al detectar el
 * locale y la escribe el selector de idioma cuando el usuario
 * cambia explícitamente.
 */
export const LOCALE_COOKIE_NAME = 'bailafm_locale';

/** 1 año en segundos. */
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
